import { Component, Fragment, h, Prop, State } from '@stencil/core';
import { Unsubscribe } from '@stencil/redux';
import Pragotron from '../svg-elements/pragotron';
import { store } from '../../../redux/store';
import { RootState } from '../../../redux/reducers';
import { intervalToDuration } from 'date-fns';

@Component({
  tag: 'rtr-pragotron',
  styleUrl: 'style.sass',
  shadow: true,
})
export class RtrPragotron {
  private intervalId: number;
  @State() timestamp: number; // value is updated by interval callback in order to trigger re-render
  @Prop({ mutable: true }) expiresAt: number;
  @Prop({ mutable: true }) expirationSettingTime: number;

  unsubscribe!: Unsubscribe;

  connectedCallback() {
    this.intervalId = setInterval(() => {
      if (!this.expiresAt) {
        return;
      }

      this.timestamp = new Date().getTime();
    }, 1000);
  }

  componentWillLoad() {
    this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
      return {
        expiresAt: state.orderDetails?.expiresAt,
        expirationSettingTime: state.system.widgetConfig.advanced.cart.expiration,
      };
    });
  }

  disconnectedCallback() {
    this.unsubscribe();
    clearInterval(this.intervalId);
  }

  get showHours() {
    return this.expirationSettingTime > 60;
  }

  get expirationString(): string {
    const expirationDate = new Date((this.expiresAt || 0) * 1000);
    const nowDate = new Date();
    const duration = intervalToDuration({ start: nowDate, end: expirationDate });
    const hours = this.showHours ? String(duration.hours || '00') + ':' : '';
    const minutes = String(duration.minutes || '00').padStart(2, '0') + ':';
    const seconds = String(duration.seconds || '00').padStart(2, '0');

    return hours + minutes + seconds;
  }

  get expirationNextString(): string {
    const expirationDate = new Date(((this.expiresAt || 0) - 1) * 1000);
    const nowDate = new Date();
    const duration = intervalToDuration({ start: nowDate, end: expirationDate });
    const hours = this.showHours ? String(duration.hours || '00') + ':' : '';
    const minutes = String(duration.minutes || '00').padStart(2, '0') + ':';
    const seconds = String(duration.seconds || '00').padStart(2, '0');

    return hours + minutes + seconds;
  }

  get expiredAlready(): boolean {
    return this.expiresAt * 1000 < new Date().valueOf();
  }

  get renderTimeFields() {
    if (this.expiredAlready) {
      return (
        <Fragment>
          <div class="NumberContainer NumberContainerExpired">0</div>
          <div class="EmptyField NumberContainerExpired">:</div>
          <div class="NumberContainer NumberContainerExpired">0</div>
          <div class="NumberContainer NumberContainerExpired">0</div>
        </Fragment>
      );
    }

    const expirationArray = this.expirationString.split('');
    const expirationNextArray = this.expirationNextString.split('');

    return expirationArray.map((fieldValue, index) => {
      if (fieldValue === ':') {
        return <div class="EmptyField">:</div>;
      }

      const nextFieldValue = expirationNextArray[index];

      return (
        <div class="NumberContainer">
          <div class="TopUnder">
            <div class="InsideContainer">{nextFieldValue}</div>
          </div>
          <div class="TopUp" key={nextFieldValue}>
            <div class="InsideContainer">{fieldValue}</div>
          </div>
          <div class="BottomUp" key={nextFieldValue}>
            <div class="InsideContainer">{nextFieldValue}</div>
          </div>
          <div class="BottomUnder">
            <div class="InsideContainer">{fieldValue}</div>
          </div>
        </div>
      );
    });
  }

  render() {
    return (
      <div class="PragotronContainer">
        <Pragotron />
        <div class="PragotronNumbers">
          {this.renderTimeFields}
          <div class="PragotronLine" />
        </div>
      </div>
    );
  }
}
